import http from './http'

const base = '/jetlinks/visualization/control-groups'
const groupPath = id => base + '/' + encodeURIComponent(id)

// 群组管理不下发设备指令，也不使用全量设备查询。
export const queryControlGroups = (data, options = {}) => http.post(base + '/_query', data, options)
export const getControlGroup = (id, options = {}) => http.get(groupPath(id), options)
export const createControlGroup = data => http.post(base + '/_add', data)
export const updateControlGroup = (id, data) => http.post(groupPath(id) + '/_update', data)
export const deleteControlGroup = (id, data) => http.post(groupPath(id) + '/_delete', data)
export const queryControlGroupProducts = (data, options = {}) => http.post(base + '/products/_query', data, options)
export const queryControlGroupMembers = (id, data, options = {}) => http.post(groupPath(id) + '/members/_query', data, options)
export const queryControlGroupCandidates = (id, data, options = {}) => http.post(groupPath(id) + '/candidates/_query', data, options)
export const addControlGroupMembers = (id, data) => http.post(groupPath(id) + '/members/_add', data)
export const removeControlGroupMembers = (id, data) => http.post(groupPath(id) + '/members/_remove', data)
